module.exports = __webpack_public_path__ + "img/tips_email.e7c4fa9a.svg";